import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LandingPage from './LandingPage.vue';
import StatsHeader from './StatsHeader.vue';
import Stats from './Stats.vue';
import WorkHistory from './WorkHistory.vue';
import ConsultingProjects from './ConsultingProjects.vue';
import Portfolio from './Portfolio.vue';
import Contact from '@/components/Contact.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(LandingPage),
    _createVNode(StatsHeader),
    _createVNode(Stats),
    _createVNode(WorkHistory),
    _createVNode(ConsultingProjects),
    _createVNode(Portfolio),
    _createVNode(Contact)
  ]))
}
}

})